import { Box, Typography } from "@mui/material";
import React from "react";
import MenuSortableTree from "./components/MenuSortableTree";

const DefineMenu = () => {
  return (
    <>
      <Box
        width={"100%"}
        height={{
          sm: "100vh",
          xs: "100vh",
          md: "85vh",
          lg: "85vh",
          xl: "85vh",
        }}
        border={"1.5px solid #DAE0E4"}
        borderRadius={"5px"}
        padding={"2rem"}
      >
        <Typography
          style={{
            color: "#1D4A87",
            fontSize: "18px",
            width: "fit-content",
            marginTop: "-40px",
            marginRight: "23px",
            background: "#fff",
          }}
          sx={{ paddingX: "5px" }}
        >
          تعریف منو
        </Typography>
        <Box sx={{ marginTop: "2rem" }}>
          <MenuSortableTree />
        </Box>
      </Box>
    </>
  );
};

export default DefineMenu;
